import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/data";

export default function HomeCategories() {
  return (
    <section className="bg-[#f5f5f5] py-24 md:py-32" data-testid="home-categories">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="overline mb-4">Catálogo · 08 Categorias</div>
            <h2 className="font-display font-bold uppercase text-4xl md:text-5xl text-[#0d4c7d] leading-[0.95] tracking-tight max-w-2xl">
              Gama completa para<br />cada desafio industrial.
            </h2>
          </div>
          <Link to="/produtos" data-testid="home-view-all-products" className="btn-cet btn-dark self-start">
            Ver Todos <ArrowUpRight size={18} />
          </Link>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {CATEGORIES.map((c, idx) => (
            <Link
              to="/produtos"
              key={c.slug}
              data-testid={`home-category-${c.slug}`}
              className="cat-card group block"
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-[#111]">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className="cat-img w-full h-full object-cover opacity-90"
                />
                <div className="cat-overlay absolute inset-0" />
                <div className="absolute top-4 left-4 font-mono-cet text-xs tracking-widest text-white/90">
                  CAT — {c.code}
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="font-display font-bold text-white uppercase text-xl leading-tight">{c.title}</div>
                  <div className="text-xs text-white/70 mt-1">{c.short}</div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
